import { useTradeSettingsStore } from '@/stores/tradeSettingsStore'
import { computed, type Ref } from 'vue'

export const useTriggerSettings = (root: Ref<string | null>, cacheKey: string) => {
  const tradeSettingsStore = useTradeSettingsStore()

  const triggerValue = computed({
    get: () =>
      root.value && cacheKey ? (tradeSettingsStore.getSetting(root.value, cacheKey) ?? null) : null,
    set: (value) => {
      if (root.value && cacheKey) {
        tradeSettingsStore.setSetting(root.value, cacheKey, value)
      }
    },
  })

  const recCacheKey = `rec_${cacheKey}`
  const recTriggerValue = computed({
    get: () =>
      root.value && recCacheKey
        ? (tradeSettingsStore.getSetting(root.value, recCacheKey) ?? null)
        : null,
    set: (value) => {
      if (root.value && recCacheKey) {
        tradeSettingsStore.setSetting(root.value, recCacheKey, value)
      }
    },
  })

  return {
    triggerValue,
    recTriggerValue,
  }
}
